var chunkMapping = {
	"439": [
		9861,
		9771,
		5324,
		4199,
		680,
		4651,
		2951,
		2027,
		5436,
		2049,
		9719,
		8530,
		3056,
		2011
	],
	"725": [
		9459
	],
	"891": [
		5022,
		5450
	]
};
var idToExternalAndNameMapping = {
	"680": [
		"default",
		"./moment",
		5645
	],
	"2011": [
		"default",
		"./redux-logger",
		5645
	],
	"2027": [
		"default",
		"./react-draggable",
		5645
	],
	"2049": [
		"default",
		"./react-resizable",
		5645
	],
	"2951": [
		"default",
		"./react-color",
		5645
	],
	"3056": [
		"default",
		"./redux-actions",
		5645
	],
	"4199": [
		"default",
		"./lodash",
		5645
	],
	"4651": [
		"default",
		"./prop-types",
		5645
	],
	"5022": [
		"default",
		"./xss",
		5645
	],
	"5324": [
		"default",
		"./classnames",
		5645
	],
	"5436": [
		"default",
		"./react-redux",
		5645
	],
	"5450": [
		"default",
		"./axios",
		5645
	],
	"8530": [
		"default",
		"./redux",
		5645
	],
	"9459": [
		"default",
		"./i18n",
		3298
	],
	"9719": [
		"default",
		"./react-sortablejs",
		5645
	],
	"9771": [
		"default",
		".",
		3298
	],
	"9861": [
		"default",
		".",
		6283
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}